import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useWallet } from '../../chain/WalletContext';
import { walletSignIn } from '../../chain/walletAuth';
import { shortAddress, CHAIN } from '../../chain/config';
import { BpMark } from '../BpLogo';

export default function Login() {
    const { address, connect, hasWallet } = useWallet();
    const [phase, setPhase] = useState('idle'); // idle | connecting | signing
    const [error, setError] = useState('');

    const signIn = async () => {
        setError('');
        try {
            let addr = address;
            if (!addr) {
                setPhase('connecting');
                addr = await connect();
                if (!addr) { setPhase('idle'); return; }
            }
            setPhase('signing');
            const result = await walletSignIn(addr);
            toast.success(`Welcome back${result.user.username ? ', ' + result.user.username : ''}!`);
            window.location.replace(result.user.role === 'SELLER' ? '/dashboard' : '/');
        } catch (err) {
            setPhase('idle');
            if (err.message === 'NO_WALLET') {
                setError('No wallet detected — install BirrWallet or MetaMask to continue.');
            } else {
                setError(err.message);
            }
        }
    };

    return (
        <div className="bp-auth-page">
            <div className="bp-auth-card">
                <div className="bp-auth-mark"><BpMark size={52} /></div>
                <h1>Welcome back</h1>
                <p className="bp-auth-sub">
                    Your wallet is your account. Sign a message to prove it's you —
                    <strong> no passwords, ever.</strong>
                </p>

                {address && (
                    <div className="bp-auth-wallet-pill">
                        <span className="bp-wallet-dot live" />
                        <span className="bp-mono">{shortAddress(address)}</span>
                        <span className="bp-dim">connected</span>
                    </div>
                )}

                <button className="bp-btn-primary bp-auth-cta" onClick={signIn} disabled={phase !== 'idle'}>
                    {phase === 'connecting' ? 'Connecting wallet…'
                        : phase === 'signing' ? 'Check your wallet — sign the message'
                        : address ? 'Sign In' : 'Connect Wallet & Sign In'}
                </button>

                {error && <p className="bp-auth-error">{error}</p>}

                <div className="bp-auth-steps">
                    <div><span>1</span> Connect your wallet</div>
                    <div><span>2</span> Sign a free message</div>
                    <div><span>3</span> You're in</div>
                </div>

                <div className="bp-auth-links">
                    <span>New to BirrPlug? <Link to="/signup">Create an account</Link></span>
                    <span>Want to sell? <Link to="/join">Open a shop</Link></span>
                </div>

                {!hasWallet && (
                    <a className="bp-auth-getwallet" href="https://birr.foundation/wallet" target="_blank" rel="noreferrer">
                        Don't have a wallet? Get BirrWallet ↗
                    </a>
                )}
                <p className="bp-auth-chain bp-dim">Secured by {CHAIN.name} · signing costs nothing</p>
            </div>
        </div>
    );
}
